import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">专题索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按分类浏览51大赛全部内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, index) => (
            <div
              key={index}
              className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 cursor-pointer hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${item.icon} text-lg text-primary-600 group-hover:text-background-50 transition-colors duration-200`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.count} 项内容</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}